import './styles/index.scss';
import './setupVue';
import './setupVeeValidate';
import './setupZxcvbn';
import Vue from 'vue';
import App from './App.vue';
import i18n from './i18n';
import store from './store';
import router from './router';

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
